import { Component, inject, OnInit } from '@angular/core';
import { DictionaryService } from '@cudirect/shared-ui-library';
import { OLACustomPage } from '../custom-page.types';
import { CorePageBaseComponent } from '@workflow/dynamic-render/page/shared/core-page-base.component';
import { WorkflowPageNavigationService } from '@workflow/service/workflow-page-navigation/workflow-page-navigation.service';
import { WorkflowWidgetEventServiceService } from '@workflow/widget/workflow-widget-event.service';
import { StatefulService } from '@app/service/stateful.service';
/** Elegibility component for OLA flow */
@OLACustomPage('ola-eligibility')
@Component({
  selector: 'ecp-ola-eligibility',
  templateUrl: './ola-eligibility.component.html',
  standalone: false
})
export class OlaEligibilityComponent extends CorePageBaseComponent implements OnInit {
  private readonly statefulService = inject(StatefulService);

  /** Checklist Description */
  public checklistDescription: string;
  /** Checklist Enabled Status */
  public checklistEnabled: boolean;

  constructor(
    public workflowPageNavigationService: WorkflowPageNavigationService,
    public readonly EventService: WorkflowWidgetEventServiceService,
    private readonly dictionaryService: DictionaryService
  ) {
    super(workflowPageNavigationService, EventService);
  }

  public ngOnInit(): void {
    const checklist = this.statefulService.wrap('ss:ola-loan-product-checklist-description').valueString;
    this.checklistEnabled = this.statefulService.wrap('ss:ola-loan-product-checklist-enabled').value as boolean;
    this.checklistDescription = checklist || this.dictionaryService.read('ola-eligibility/checklistdescription');
  }
}
